var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 9.9987C2.66663 9.9987 3.33329 9.33203 5.33329 9.33203C7.33329 9.33203 8.66663 10.6654 10.6666 10.6654C12.6666 10.6654 13.3333 9.9987 13.3333 9.9987V1.9987C13.3333 1.9987 12.6666 2.66536 10.6666 2.66536C8.66663 2.66536 7.33329 1.33203 5.33329 1.33203C3.33329 1.33203 2.66663 1.9987 2.66663 1.9987V9.9987Z",
    stroke: "#475569",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 14.6667V10",
    stroke: "#475569",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.2aad3e725b48a5755ec8771f5661a5a7.svg";
export { ForwardRef as ReactComponent };